module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<h1>Sending Message</h1>\n';
 if(processing) { 
__p+='\n<div class="processing">\n    <img src="/static/icons/cog.svg" class="cogicon" /><br/>\n    Your message is being sent. Just a moment please...\n</div>\n';
 } else { 
__p+='\n<div class="processing done">\n    <img src="/static/icons/tick.svg" class="picon" /><br/>\n    Your message was sent successfully\n</div>\n<button class="btn-close button-secondary button">\n    Close\n</button>\n';
 } 
__p+='\n';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./messaging/templates/processing.html
// module id = 286
// module chunks = 0